import { useEffect, useState } from "react";
import { AuthTokenRetrieve, LoginButton } from "../Utility/AuthTokenRetrieve";
import { apiFetch } from "../Utility/api";
import "../Food/RecipeList.css";
import "./FoodDiary.css";
import { defaultSymptomForm, fetchDiarySymptoms } from "./FoodDiaryShared";

const FoodDiaryAddSymptom = () => {
  const [shouldShow, setShouldShow] = useState();
  const [symptomForm, setSymptomForm] = useState(defaultSymptomForm());
  const [savingSymptom, setSavingSymptom] = useState(false);
  const [symptomStatus, setSymptomStatus] = useState("");
  const { shouldShow: shouldShowGoogle } = AuthTokenRetrieve();

  useEffect(() => {
    setShouldShow(shouldShowGoogle);
  }, [shouldShowGoogle]);

  const handleSymptomChange = (event) => {
    const { name, value } = event.target;
    setSymptomForm((currentValue) => ({ ...currentValue, [name]: value }));
  };

  const handleSymptomSubmit = async (event) => {
    event.preventDefault();
    setSavingSymptom(true);
    setSymptomStatus("");

    try {
      const response = await apiFetch("/food/diary/symptoms", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          startedAt: symptomForm.startedAt,
          endedAt: symptomForm.endedAt || "",
          symptomType: symptomForm.symptomType,
          severity: Number(symptomForm.severity || 1),
          notes: symptomForm.notes,
        }),
      });
      const result = await response.json();
      if (!result.symptom?.id) {
        throw new Error("Symptom save failed");
      }

      await fetchDiarySymptoms();
      setSymptomForm(defaultSymptomForm());
      setSymptomStatus("Symptom logged");
    } catch (err) {
      setSymptomStatus(err.message ? err.message : "Unable to save symptom");
    }

    setSavingSymptom(false);
  };

  if (!shouldShow) {
    return (
      <div className="searchBarDiv formViewWrapper FoodDiaryLogin">
        <h2>Food diary</h2>
        <p>Sign in to add private symptom entries.</p>
        <LoginButton setShouldShow={setShouldShow}></LoginButton>
      </div>
    );
  }

  return (
    <div className="searchBarDiv formViewWrapper FoodDiaryPanel FoodDiarySinglePanel">
      <h2 className="FoodDiaryTitle">Add symptom</h2>
      <p className="FoodDiarySubtitle">
        Capture symptoms as they happen so meal timing stays useful later.
      </p>
      <form onSubmit={handleSymptomSubmit}>
        <div className="FoodDiaryTwoColumn">
          <div className="inputDiv">
            <label>Started</label>
            <input
              type="datetime-local"
              className="inputBox addInput"
              name="startedAt"
              value={symptomForm.startedAt}
              onChange={handleSymptomChange}
            />
          </div>
          <div className="inputDiv">
            <label>Ended</label>
            <input
              type="datetime-local"
              className="inputBox addInput"
              name="endedAt"
              value={symptomForm.endedAt}
              onChange={handleSymptomChange}
            />
          </div>
        </div>

        <div className="FoodDiaryTwoColumn">
          <div className="inputDiv">
            <label>Symptom</label>
            <select
              className="inputBox addInput"
              name="symptomType"
              value={symptomForm.symptomType}
              onChange={handleSymptomChange}
            >
              <option>Bloating</option>
              <option>Cramping</option>
              <option>Urgency</option>
              <option>Gas</option>
              <option>Nausea</option>
              <option>Reflux</option>
              <option>Other</option>
            </select>
          </div>
          <div className="inputDiv">
            <label>Severity (1-10)</label>
            <input
              className="inputBox addInput"
              name="severity"
              value={symptomForm.severity}
              onChange={handleSymptomChange}
            />
          </div>
        </div>

        <div className="inputDiv">
          <label>Notes</label>
          <textarea
            className="inputBox textAreaAdd FoodDiaryTextarea"
            name="notes"
            value={symptomForm.notes}
            onChange={handleSymptomChange}
          />
        </div>

        {symptomStatus ? <p className="FoodDiaryStatus">{symptomStatus}</p> : null}
        <button type="submit" className="summaryButton" disabled={savingSymptom}>
          {savingSymptom ? "Saving..." : "Save Symptom"}
        </button>
      </form>
    </div>
  );
};

export default FoodDiaryAddSymptom;
